import { useState, useCallback } from "react";
import { ProfileSearch } from "../../services/scim";
import { useScimData } from "../../utils/useScimData";
import { GetPatient } from "../../services/fhir";
import { toast } from "react-toastify";

interface UseAuthReturn {
  user: any;
  userPatient: any;
  loading: boolean;
  fetchUser: () => Promise<any>;
}

export const useUserData = (): UseAuthReturn => {
  const [user, setUser] = useState({});
  const [userPatient, setUserPatient] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const fetchUser = useCallback(async () => {
    setLoading(true);
    try {
      const Scim2UserResponse = await ProfileSearch().then(
        (response) => response?.Resources
      );

      if (Scim2UserResponse) {
        const extractScim2Data = useScimData.getUser(Scim2UserResponse);
        setUser(extractScim2Data);

        const patient = await GetPatient({
          identifier: extractScim2Data.username,
        });
        setUserPatient(patient?.data);

        return { extractScim2Data, patient: patient?.data };
      }
      throw new Error("Usuário não encontrado");
    } catch (error) {
      toast.error("Erro ao carregar dados do usuário");
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  return { user, userPatient, loading, fetchUser };
};
